module.exports = {
  "id": "bouncify",
  "color": "green",
  "title": "bouncify",
  "icon": "bouncify",
  "category": "movement",
  "description": "Make a piece bounce",

  "searchTags": ["ball","trampoline","jump","hop","bouncy"],
  "exposedVariables": [
    
    {
      "spriteName": "$glitch_target",
      "variableName": "bounciness",
      "tooltip":"Set the amount the piece will bounce",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "1",
        "step": ".05"
      },
      "value": ".5"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "friction",
      "tooltip":"Set the amount of friction the piece will experience",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "1",
        "step": ".05"
      },
      "value": ".33"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "velocity x",
      "tooltip":"Set the amount of horizontal velocity the piece will have",
      "input": {
        "type": "slider",
        "options": [],
        "min": "-50",
        "max": "50",
        "step": ".1"
      },
      "value": "0"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "velocity y",
      "tooltip":"Set the amount of vertical velocity the piece will have",
      "input": {
        "type": "slider",
        "options": [],
        "min": "-50",
        "max": "50",
        "step": ".1"
      },
      "value": "0"
    }

  ],
  "info": [
    {
      "text": "Make a piece bouncy",
      "image": "provision/glitches/bouncify/bouncify.gif"
    }
  ],
  "codeImage": "provision/glitches/bouncify/bouncify.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/bouncify/bouncify.svg"
};